import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { backgroundColorAlt } from "@churchofjesuschrist/eden-style-constants";
import TR from "./TR";

// The additional "odd/even" selectors are to override the "odd" selector in
//`TBody` to make sure the first data row is always background of `grey2`.
import { jsx as _jsx } from "react/jsx-runtime";
const StyledFilterRow = styled(TR).withConfig({
  componentId: "sc-34v8ge-0"
})(["tbody &{background-color:", ";}"], backgroundColorAlt);

/** A styled row for filtering controls. Should be used as the first row in a <TBody>. */
const FilterRow = _ref => {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx(StyledFilterRow, {
    ...props,
    noSelection: true,
    children: children
  });
};
export { StyledFilterRow };
export default FilterRow;
FilterRow.propTypes = {
  /** The `<TD>` cells containing filtering controls. */
  children: PropTypes.node
};